import React from 'react';
import { LinkButton } from 'fronton-react';
import { PencilSimpleIcon } from '@fronton/icons-react';

export const EditParamsButton: React.FC = () => (
  <LinkButton
    data-testid="edit-params-button"
    iconLeft={<PencilSimpleIcon />}
    size="xs"
    variant="secondary"
    type="submit">
    Изменить
  </LinkButton>
);
